import { useEffect } from 'react';
import { StyleGallery } from '../components/StyleGallery';
import { AuthProvider } from '../contexts/AuthContext';
import { initAnalytics } from '../utils/analytics';

export function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <AuthProvider>
      <StyleGallery />
    </AuthProvider>
  );
}
